export default "__VITE_ASSET__BBLmXrPs__"